var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import translations from './translations';
import css from './style.pcss';
import ArrowDownIcon from "../../common/images/arrow-down-white.svg";
var RTLMeteo = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLMeteo, _LitElement);
  function RTLMeteo() {
    var _this;
    _classCallCheck(this, RTLMeteo);
    _this = _callSuper(this, RTLMeteo);
    _this.language = 'lu';
    _this.assetsUrl = 'https://rtl-sites-assets.rtl.lu';
    _this.type = 'today';
    _this.rendered = false;
    _this.themeClass = 'rtl';
    var sId = localStorage.getItem('rtlWeatherStationId');
    _this.station = sId || 3;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
      _this.themeClass = window.rtlsites.config.site;
    }
    return _this;
  }
  _createClass(RTLMeteo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLMeteo.prototype), "connectedCallback", this).call(this);
      this._fetchData();
      this.themeClass = this.site;
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      if (this.data != undefined) return;
      this.apiUrl = 'https://www.rtl.lu/api/meteo';
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_updateCurrentStation",
    value: function _updateCurrentStation(e) {
      this.station = e.target.value;
      localStorage.setItem('rtlWeatherStationId', this.station);
    }
  }, {
    key: "_renderDetail",
    value: function _renderDetail() {
      var _this3 = this;
      var stations = this.data.stations.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      var aussichten = this.data.aussichten;
      var astro = this.data.astronomy.filter(function (astro) {
        return astro.station_id == _this3.station;
      });
      var observation = this.data.observation.filter(function (obs) {
        return obs.station_id == _this3.station;
      });
      var forecasts = this.data.forecast;
      forecasts = forecasts.filter(function (forecast) {
        return forecast.station_id == _this3.station;
      });
      var showDetails = false;
      if (observation.length > 0 && (observation[0].niederschlag > -9000 || observation[0].windmittel > -9000 || observation[0].windspitze > -9000)) showDetails = true;
      var lastDay = null;
      var imgFolder = 'weather';
      return html(_t || (_t = _`
            <div class="rtl-meteo-detail">
                <div class="rtl-meteo__aussichten rtl-meteo-aussichten">
                    <div class="rtl-meteo-aussichten__title">${0} →</div>
                    <div class="rtl-meteo-aussichten__container">
                        ${0}
                    </div>
                </div>

                <div class="rtl-meteo-detail__container">
                    <div class="rtl-meteo-detail__weather-today">
                        <div class="rtl-meteo-detail__date-today">${0}</div>
                        <select class="rtl-meteo-detail__city" style="background-image: url('${0}/images/ic_arrow-down_light.svg'); background-size: 20px;" @change=${0}>
                            ${0}
                        </select>
                    </div>

                    ${0}
                </div>

                ${0}

            </div>
        `), this._getTranslation('aussichten'), aussichten.map(function (aussicht) {
        return html(_t2 || (_t2 = _`
                        <div class="rtl-meteo-aussichten__day-container">
                            <h3 class="rtl-meteo-aussichten__day">${0}</h3>
                            <div class="rtl-meteo-aussichten__icon-temp-container">
                                <div class="rtl-meteo-aussichten_icon"><img src="${0}/images/weather/icons_svg_dark/${0}.svg" class="rtl-meteo-aussichten__icon-img"/></div>
                                <div class="rtl-meteo-aussichten__temp">
                                    <span class="rtl-meteo-aussichten__max">${0}°</span> /
                                    <span class="rtl-meteo-aussichten__min">${0}°</span>
                                </div>
                            </div>
                        </div>
                        `), _this3._getTranslation(dayjs(aussicht.luxembourg_time).day()), _this3.assetsUrl, aussicht.wettersymbol, aussicht.hoechsttemperatur, aussicht.tiefsttemperatur);
      }), new dayjs().format('DD.MM.YYYY - HH:mm'), this.assetsUrl, function (e) {
        return _this3._updateCurrentStation(e);
      }, stations.map(function (station) {
        return html(_t3 || (_t3 = _`
                                ${0}
                            `), station.id == _this3.station ? html(_t4 || (_t4 = _`<option value="${0}" selected>${0}</option>`), station.id, _this3._getTranslation('station' + station.id)) : html(_t5 || (_t5 = _`<option value="${0}">${0}</option>`), station.id, _this3._getTranslation('station' + station.id)));
      }), observation.length > 0 ? html(_t6 || (_t6 = _`
                    <div class="rtl-meteo-detail__obs rtl-meteo-obs">
                        <div class="rtl-meteo-obs__intro-container">
                            <div class="rtl-meteo-obs__intro">
                                ${0}
                                <div class="rtl-meteo-obs__icon"><img src="${0}/images/weather/icons_svg_dark/${0}.svg" class="rtl-meteo-obs__icon-img"/></div>
                            </div>

                            ${0}
                        </div>

                        ${0}
                    </div>
                    `), observation[0].temperatur > -9000 ? html(_t7 || (_t7 = _`<div class="rtl-meteo-obs__temperature">${0}°</div>`), observation[0].temperatur) : '', this.assetsUrl, observation[0].wettersymbol, astro.length > 0 ? html(_t8 || (_t8 = _`
                            <div class="rtl-meteo__sun">
                                <div class="rtl-meteo__sun-content"><img class="rtl-meteo__sun-img" src="${0}/images/weather/ic_sunrise.svg"/>${0}</div>
                                <div class="rtl-meteo__sun-content"><img class="rtl-meteo__sun-img" src="${0}/images/weather/ic_sunset.svg"/>${0}</div>
                            </div>
                            `), this.assetsUrl, astro[0].sonnenaufgang.substring(0, 5), this.assetsUrl, astro[0].sonnenuntergang.substring(0, 5)) : '', showDetails ? html(_t9 || (_t9 = _`
                        <div class="rtl-meteo-details__data">
                            <h3 class="rtl-meteo-details__title">${0}</h3>
                            <table class="rtl-meteo-details__table">
                                ${0}
                                ${0}
                                ${0}
                            </table>
                        </div>
                        `), this._getTranslation('detailer'), observation[0].niederschlag > -9000 ? html(_t10 || (_t10 = _`<tr><td class="rtl-meteo-details__td-title">${0}<td></td><td class="rtl-meteo-details__td">${0} mm</td></tr>`), this._getTranslation('niederschlag'), observation[0].niederschlag) : '', observation[0].windmittel > -9000 ? html(_t11 || (_t11 = _`<tr><td class="rtl-meteo-details__td-title">${0}<td></td><td class="rtl-meteo-details__td"><img class="rtl-meteo-details__wind-img" style="transform: rotate(${0}deg)" src="${0}/images/${0}/ic_wind-direction.svg" class="rtl-wiederfraesch__icon"> <div class="rtl-meteo-details__wind">${0} km/h</div></td></tr>`), this._getTranslation('wind'), Number(observation[0].windrichtung) + 45, this.assetsUrl, imgFolder, observation[0].windmittel) : '', observation[0].windspitze > -9000 ? html(_t12 || (_t12 = _`<tr><td class="rtl-meteo-details__td-title">${0}<td></td><td class="rtl-meteo-details__td">${0} km/h</td></tr>`), this._getTranslation('windspitze'), observation[0].windspitze) : '') : '') : '', forecasts.length > 0 ? html(_t13 || (_t13 = _`
                <div class="rtl-meteo-forecast">
                    ${0}
                </div>
                `), forecasts.map(function (forecast) {
        var dateRow = null;
        if (lastDay && lastDay !== dayjs(forecast.dtg_iso).format('d')) {
          dateRow = html(_t14 || (_t14 = _`<div class="rtl-meteo-forecast__date">
                            ${0}
                        </div>`), dayjs(forecast.dtg_iso).format('DD.MM.YYYY'));
        }
        lastDay = dayjs(forecast.dtg_iso).format('d');
        return html(_t15 || (_t15 = _`

                        ${0}

                    <div class="rtl-meteo-forecast__item">
                        <div class="rtl-meteo-forecast__time-container">
                            <div class="rtl-meteo-forecast__time">
                                ${0}
                            </div>
                            <div class="rtl-meteo-forecast__button"></div>
                        </div>
                        <div class="rtl-meteo-forecast__detail-container">
                            <div class="rtl-meteo-forecast__temperature-container">
                                <div class="rtl-meteo-forecast__icon"><img class="rtl-meteo-forecast__icon-img" src="${0}/images/weather/icons_svg_dark/${0}.svg"/></div>
                                <div class="rtl-meteo-forecast__temperature">${0}°</div>
                            </div>

                            <table class="rtl-meteo-forecast__table">
                                <tr class="rtl-meteo-forecast__tr">
                                    <td class="rtl-meteo-forecast__td-img"><img class="rtl-meteo-forecast__img" src="${0}/images/${0}/ic_sunshine.svg"></td>
                                    <td class="rtl-meteo-forecast__name">${0}</td>
                                    <td class="rtl-meteo-forecast__item-detail rtl-meteo-forecast__sunshine-detail-td">${0} min</td>
                                </tr>
                                <tr class="rtl-meteo-forecast__tr">
                                    <td class="rtl-meteo-forecast__td-img"><img class="rtl-meteo-forecast__img rtl-meteo-forecast__img--rain" src="${0}/images/${0}/ic_rain.svg"></td>
                                    <td class="rtl-meteo-forecast__name">${0}</td>
                                    <td class="rtl-meteo-forecast__item-detail rtl-meteo-forecast__rain-detail-td">${0} mm</td>
                                </tr>
                                <tr class="rtl-meteo-forecast__tr">
                                    <td class="rtl-meteo-forecast__td-img"><img class="rtl-meteo-forecast__img" style="transform: rotate(${0}deg)" src=" ${0}/images/${0}/ic_wind-direction.svg?v=1"></td>
                                    <td class="rtl-meteo-forecast__name">${0}</td>
                                    <td class="rtl-meteo-forecast__item-detail rtl-meteo-forecast__wind-detail-td">${0} km/h</td>
                                </tr>
                                <tr class="rtl-meteo-forecast__tr">
                                    <td class="rtl-meteo-forecast__td-img"><img class="rtl-meteo-forecast__img" src="${0}/images/${0}/ic_wind-speed.svg"></td>
                                    <td class="rtl-meteo-forecast__name">${0}</td>
                                    <td class="rtl-meteo-forecast__item-detail rtl-meteo-forecast__windmax-detail-td">${0} km/h</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    `), dateRow, dayjs(forecast.dtg_iso).format('HH:mm'), _this3.assetsUrl, forecast.wettersymbol, forecast.temperatur, _this3.assetsUrl, imgFolder, _this3._getTranslation('sonnenschein'), forecast.sonnenscheindauer, _this3.assetsUrl, imgFolder, _this3._getTranslation('niederschlag'), forecast.niederschlag, Number(forecast.windrichtung) + 45, _this3.assetsUrl, imgFolder, _this3._getTranslation('wind'), forecast.windmittel, _this3.assetsUrl, imgFolder, _this3._getTranslation('windspitze'), forecast.windspitze);
      })) : '');
    }
  }, {
    key: "_renderForecast",
    value: function _renderForecast() {
      var _this4 = this;
      var forecasts = this.data.aussichten;
      return html(_t16 || (_t16 = _`
            <div class="rtl-meteo__aussichten rtl-meteo-aussichten">
                <div class="rtl-meteo-aussichten__title">${0} →</div>
                <div class="rtl-meteo-aussichten__container">
                    ${0}
                </div>
            </div>
        `), this._getTranslation('aussichten'), forecasts.map(function (forecast) {
        return html(_t17 || (_t17 = _`
                    <div class="rtl-meteo-aussichten__day">
                        <h3 class="rtl-meteo-aussichten__subtitle">${0}</h3>
                        <div class="rtl-meteo-aussichten__icon-temp-container">
                            <div class="rtl-meteo-aussichten_icon"><img src="${0}/images/weather/icons_bg-white/x2/${0}.png?v=9" class="rtl-meteo-aussichten__icon-img"/></div>
                            <div class="rtl-meteo-aussichten__temp">
                                <span class="rtl-meteo-aussichten__min">${0}°</span> |
                                <span class="rtl-meteo-aussichten__max">${0}°</span>
                            </div>
                        </div>
                    </div>
                    `), _this4._getTranslation(dayjs(forecast.luxembourg_time).format('d')), _this4.assetsUrl, forecast.wettersymbol, forecast.tiefsttemperatur, forecast.hoechsttemperatur);
      }));
    }
  }, {
    key: "_renderAussichten",
    value: function _renderAussichten() {
      var _this5 = this;
      var forecasts = this.data.aussichten;
      var link = '/meteo';
      if (this.language == 'fr') link = '/services/meteo';
      if (this.language == 'en') link = '/info/weather';
      var addClass = '';
      var eltronaDiv = null;
      var sponsorDiv = null;
      // if (this.with_sponsor && window.rtlsites.config.site === 'rtltoday') {
      //     // sponsorDiv = html`<a href="https://www.enoblog.lu/en/?utm_medium=display&utm_source=rtltoday&utm_campaign=lu.sponsorship.brand.enoblog.&utm_term=logo.&utm_content=en.enoblog" target="_blank"><div class="rtl-meteo-aussichten-today__box-partner"><img class="meteo-aussichten-today__img" src="${this.assetsUrl}/images/partner/logo-enovos-white.svg?v=10" class="rtl-meteo-aussichten-today__partner"/></div>`
      // }

      return html(_t18 || (_t18 = _`
            <div class=${0}>
                <div class="rtl-meteo-aussichten__title">${0} →</div>
                <div class="meteo-aussichten-eldo__title-container"> ${0}</div>
                <div class="rtl-meteo-aussichten__container">
                ${0}
                </div>
                <a href="${0}" class="rtl-aussichten__link">Météo</a>
            </div>
            ${0}
        `), `rtl-meteo__aussichten rtl-meteo-aussichten--small ${addClass}`, this._getTranslation('aussichten_short'), eltronaDiv, forecasts.map(function (forecast) {
        return html(_t19 || (_t19 = _`
                    <div class="rtl-meteo-aussichten__day">
                        <h3 class="rtl-meteo-aussichten__subtitle">${0}</h3>
                        <div class="rtl-meteo-aussichten__icon-temp-container"><img src="${0}/images/weather/icons_svg_dark/${0}.svg" class="rtl-meteo-aussichten__icon-img"/></div>
                        <div class="rtl-meteo-aussichten__temp">
                            <span class="rtl-meteo-aussichten__max">${0}°</span> |
                            <span class="rtl-meteo-aussichten__min">${0}°</span>
                        </div>
                        <a href="/aktuell/meteo" class="meteo-aussichten-eldo__link-block block-link__overlay"</a>
                    </div>
                `), _this5._getTranslation(dayjs(forecast.luxembourg_time).format('d')), _this5.assetsUrl, forecast.wettersymbol, forecast.hoechsttemperatur, forecast.tiefsttemperatur);
      }), link, sponsorDiv);
    }
  }, {
    key: "_renderToday",
    value: function _renderToday() {
      var _this6 = this;
      var stations = this.data.stations.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      var astro = this.data.astronomy.filter(function (astro) {
        return astro.station_id == _this6.station;
      });
      var observations = this.data.observation.filter(function (observation) {
        return observation.temperatur > -9000;
      });
      observations.forEach(function (observation) {
        var station = stations.filter(function (station) {
          return station.id == observation.station_id;
        });
        if (station.length > 0) observation.station_name = station[0].name;
      });
      var observation = observations.filter(function (observation) {
        return observation.station_id == _this6.station;
      });
      if (observation.length == 0) {
        observation = observations[0];
        astro = this.data.astronomy.filter(function (astro) {
          return astro.station_id == observation.station_id;
        });
        astro = astro[0];
      } else {
        observation = observation[0];
        astro = astro[0];
      }
      var link = '/meteo';
      if (this.language == 'fr') link = '/services/meteo';
      if (this.language == 'en') link = '/info/weather';
      return html(_t20 || (_t20 = _`
            <select class="rtl-meteo__select rtl-meteo-select" style="background-image: url('${0}');" @change=${0}>
            ${0}
            </select>
            <div class="rtl-meteo__container">
                <div class="rtl-meteo__station">
                    <div class="rtl-meteo__icon"><img src="${0}/images/weather/icons_tv/${0}.svg?v=3" width="90"/></div>
                    <div class="rtl-meteo__temperature">${0}°</div>
                </div>

                <div class="rtl-meteo__sun">
                    <div class="rtl-meteo__sun-sunrise"><img class="rtl-meteo__sun-img" src="${0}/images/weather/sunrise.svg" width="30"/>${0}</div>
                    <div class="rtl-meteo__sun-sunset"><img class="rtl-meteo__sun-img" src="${0}/images/weather/sunset.svg" width="30"/>${0}</div>
                </div>

                <a href="${0}" class="rtl-meteo__link">Météo</a>
            </div>

        `), ArrowDownIcon, function (e) {
        return _this6._updateCurrentStation(e);
      }, observations.map(function (observation) {
        return html(_t21 || (_t21 = _`
                ${0}
            `), observation.station_id == _this6.station ? html(_t22 || (_t22 = _`<option value="${0}" selected>${0}</option>`), observation.station_id, observation.station_name) : html(_t23 || (_t23 = _`<option value="${0}">${0}</option>`), observation.station_id, observation.station_name));
      }), this.assetsUrl, observation.wettersymbol, observation.temperatur, this.assetsUrl, astro[0].sonnenaufgang.substring(0, 5), this.assetsUrl, astro[0].sonnenuntergang.substring(0, 5), link);
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      switch (this.type) {
        case 'detail':
          return this._renderDetail();
        case 'forecast':
          return this._renderForecast();
        case 'aussichten':
          return this._renderAussichten();
        case 'today':
        case 'default':
          return this._renderToday();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t24 || (_t24 = _`<div class="rtl-meteo rtl-meteo--${0}"></div>`), this.type);
      return html(_t25 || (_t25 = _`
            <style>${0}</style>
            <div class="rtl-meteo rtl-meteo--${0} rtl-meteo--${0}">
                ${0}
            </div>
        `), css, this.type, this.themeClass, this._renderDefault());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        type: {
          type: String
        },
        language: {
          type: String
        },
        station: {
          type: Number
        },
        with_sponsor: {
          type: Boolean
        },
        site: {
          type: String
        }
      };
    }
  }]);
  return RTLMeteo;
}(LitElement);
export { RTLMeteo as default };
window.customElements.define('rtl-meteo', RTLMeteo);